<template>
    <popup ref="Message" :show="show">
        <div class="ui-message ui-message-confirm">
            <div class="ui-message-header">
                <span>{{title}}</span>
                <span @click="onNo">
                    <i class="iconfont icon_close"></i>
                </span>
            </div>
            <div class="ui-message-main">
                <div class="ui-message-icon"></div>
                <div class="ui-message-title">{{tips}}</div>
                <div class="ui-message-content" v-html="content"></div>
            </div>
            <div class="ui-message-footer">
                <button class="ui-button submit" @click="onOk">{{okText}}</button>
                <button class="ui-button cancel" @click="onNo">{{noText}}</button>
            </div>
        </div>
    </popup>
</template>
<script>
import Popup from "./popup";
export default {
    name: "ui-confirm",
    components: {
        Popup
    },
    data() {
        return {
            show: false,
            duration: 0,
            title: "提示",
            tips: "",
            content: "",
            okText: "确定",
            noText: "放弃",
            ok: null,
            no: null
        };
    },
    methods: {
        onOk() {
            if (this.ok && this.ok(this) === false) {
                return;
            }
            this.onClose();
        },
        onNo() {
            this.no && this.no();
            this.onClose();
        },
        onClose() {
            setTimeout(() => {
                this.show = false;
                document.body.removeChild(this.$el);
                this.$destroy();
            }, this.duration);
        }
    }
};
</script>